import styled from '@emotion/styled'
import { css } from '@emotion/react'

export const DetailsStyles = ({ theme }) => css`
  margin: ${`0 0 ${theme.spacing.sm}`};
  padding: ${`${theme.spacing.sm} 0`};
  background-color: ${theme.colors.light.base.hex};
  display: flex;
  justify-content: space-around;
  align-items: stretch;
  font-size: 12px;
  line-height: 14px;
  width: 100%;

  > span {
    display: flex;
    align-items: center;
    justify-content: center;
    position: relative;
    flex: 1;
    padding: ${`${theme.spacing.min}  ${theme.spacing.xs}`};

    &::after {
      display: block;
      position: absolute;
      right: 0;
      top: 0;
      content: '';
      width: 1px;
      height: 100%;
      background-color: ${theme.colors.dark.lightest.hex};
    }

    &:last-of-type::after {
      display: none;
    }
  }
`

export const Details = styled.div(DetailsStyles)
